import MentoraLogo from 'Src/assets/logo.png';

const Navbar = () => (
  <nav className="py-4 md:pb-8 md:pt-6 px-4 md:mx-8">
    <div className="flex items-center gap-2 mx-auto align-end">
      <img
        src={MentoraLogo}
        alt="LiFT Logo"
        className="h-8 w-8 md:h-8 md:w-8 "
      />
      <span className="text-[16px] md:text-[32px]">
        Mentora <span className="font-bold">LiFT</span>
      </span>
    </div>
  </nav>
);

export default Navbar;
